import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../store'
import {IFetchBankKeysParams, ISerchFindocParams} from '../../api/modules/master-data/types'

export interface IFilter extends ISerchFindocParams {}

export interface IFinancialDocsState {
  isLoading?: boolean
  error?: string
  financialDocuments?: any[]
  numberUrl: string
  filter?: IFilter
  sort?: unknown
  filterBankKey?: IFetchBankKeysParams
}

const initialState: IFinancialDocsState = {
  isLoading: false,
  error: '',
  financialDocuments: [],
  numberUrl: '',
  sort: {},
  filter: {
    per_page: 25,
    findoc_number: '',
    sales_org_code: '',
    customer_id: '',
    findoc_type: '',
    bank_name: '',
    negara_desc: '',
    nilai: '',
    validity_date_from: '',
    validity_date_to: '',
    type_skbdn: '',
    incoterm: '',
    created_at: '',
    delivery_deadline: '',
    tgl_findoc: '',
    customer_name: '',
    sap_number: '',
    sector_id: '',
    num_findoc: '',
    no_skpp: '',
    currency: '',
    allowance: '',
    resedual_value: '',
    top: '',
    status: '',
  },
  filterBankKey: {
    bank_branch: '',
    bank_name: '',
    country: '',
  },
}

/**
 * Slice
 */
const financialDocs = createSlice({
  name: 'financialDocs',
  initialState,
  reducers: {
    setFinancialDocuments: (state, action) => ({...state, financialDocuments: action.payload}),
    // setFilter: (state, action) => ({...state, filter: action.payload}),
    setFilter: (state, action) => {
      localStorage.setItem('redux-findoc-filter', JSON.stringify(action.payload))
      state.filter = action.payload
    },
    setSort: (state, action) => ({...state, sort: action.payload}),
    setError: (state, action) => ({...state, error: action.payload}),
    setIsLoading: (state, action) => ({...state, isLoading: action.payload}),
    setNumberUrl: (state, action) => ({...state, numberUrl: action.payload}),
    // resetFilter: (state) => ({...state, filter: initialState.filter}),
    resetFilter: (state) => {
      localStorage.removeItem('redux-findoc-filter')
      state.filter = initialState.filter
    },
    setFilterBankKey: (state, action) => ({...state, filterBankKey: action.payload}),
  },
  extraReducers(builder) {},
})

/**
 * Action
 */
export const {
  setFinancialDocuments,
  setFilter,
  setSort,
  setError,
  setIsLoading,
  setNumberUrl,
  resetFilter,
  setFilterBankKey,
} = financialDocs.actions

/**
 * Selector
 */
export const financialDocsSelector = (state: RootState) => state.financialDocsReducer

/**
 * Reducer
 */
export default financialDocs.reducer
